{
  "familyId": "GET-KOMMA-PLUS",
  "questions": [
    {
      "id": "GET-KOMMA-PLUS-001",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 3,4 + 2,8?",
      "options": [
        "6,2",
        "5,12",
        "6,12",
        "5,2"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen optellen",
            "content": "Tel de tienden apart op. Als je 10 of meer tienden krijgt, gaat er 1 over naar de eenheden. 4 + 8 = 12 tienden = 1 heel en 2 tienden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Kijk naar de tienden: 4 + 8 = 12 tienden. 12 tienden = 1 heel en 2 tienden — de 1 gaat over naar de eenheden. Eenheden: 3 + 2 + 1 = 6. Antwoord: 6,2. Controleer: 6,2 − 2,8 = 3,4 ✓.",
        "distractorExplanations": {
          "0": "Goed! 3,4 + 2,8 = 6,2. De tienden (4 + 8 = 12) geven 1 overdracht naar de eenheden.",
          "1": "Je dacht waarschijnlijk dat 12 tienden hetzelfde is als 0,12. Maar 12 tienden = 1,2 — de 1 gaat naar de eenheden. Onthoud: 10 tienden = 1 heel, dus 12 tienden = 1 heel en 2 tienden.",
          "2": "Je dacht waarschijnlijk dat je 12 tienden gewoon achter de komma schrijft. Maar 12 tienden = 1 heel + 2 tienden. De 1 gaat naar de eenheden: 3 + 2 + 1 = 6. Antwoord: 6,2, niet 6,12. Onthoud: meer dan 9 tienden? Dan gaat er 1 over naar de eenheden.",
          "3": "Je dacht waarschijnlijk dat de overdracht niet meegeteld hoeft te worden. Maar 4 + 8 = 12 tienden → 1 overdracht. De eenheden worden 3 + 2 + 1 = 6, niet 5. Onthoud: tel de overdracht altijd mee."
        }
      }
    },
    {
      "id": "GET-KOMMA-PLUS-002",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 12,75 + 3,5?",
      "options": [
        "16,25",
        "15,25",
        "16,125",
        "15,125"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ongelijk aantal decimalen",
            "content": "Maak het aantal cijfers achter de komma gelijk door nullen toe te voegen. 3,5 = 3,50. Zet de getallen onder elkaar met de komma's recht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_honderdsten",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Maak het aantal decimalen gelijk: 3,5 = 3,50. Nu: 12,75 + 3,50. Honderdsten: 5 + 0 = 5. Tienden: 7 + 5 = 12 → schrijf 2, onthoud 1. Eenheden: 2 + 3 + 1 = 6. Tientallen: 1. Antwoord: 16,25. Controleer: 16,25 − 3,50 = 12,75 ✓.",
        "distractorExplanations": {
          "0": "Goed! 12,75 + 3,50 = 16,25. Let op de overdracht bij de tienden: 7 + 5 = 12.",
          "1": "Je dacht waarschijnlijk dat de overdracht van de tienden niet meegeteld hoeft te worden. Maar 7 + 5 = 12 tienden → 1 overdracht naar de eenheden. 2 + 3 + 1 = 6, niet 5. Onthoud: tel de overdracht altijd mee.",
          "2": "Je dacht waarschijnlijk dat 3,5 hetzelfde is als 3,05. Maar 3,5 = 3,50 (vijf tienden), niet 3,05 (vijf honderdsten). Onthoud: voeg een nul toe achteraan — 3,5 = 3,50.",
          "3": "Je hebt twee fouten gemaakt: de overdracht vergeten én 3,5 als 3,05 gelezen. Controleer: 3,5 = 3,50 en 7 + 5 = 12 → overdracht. Antwoord: 16,25."
        }
      }
    },
    {
      "id": "GET-KOMMA-PLUS-003",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Een plank is 1,85 m lang. Je plakt er een stuk van 0,6 m aan. Hoe lang is de plank nu?",
      "options": [
        "2,45 m",
        "1,91 m",
        "2,45 cm",
        "2,51 m"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen onder elkaar",
            "content": "Zet de getallen onder elkaar met de komma's recht. 1,85 + 0,60. Vul aan met nullen zodat alle getallen even lang zijn achter de komma.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zet de getallen onder elkaar met de komma's recht: 1,85 + 0,60. Honderdsten: 5 + 0 = 5. Tienden: 8 + 6 = 14 → schrijf 4, onthoud 1. Eenheden: 1 + 0 + 1 = 2. Antwoord: 2,45 m. Controleer: 2,45 − 0,60 = 1,85 ✓.",
        "distractorExplanations": {
          "0": "Goed! 1,85 + 0,60 = 2,45 m.",
          "1": "Je dacht waarschijnlijk dat 0,6 hetzelfde is als 0,06. Maar 0,6 = 0,60 (zes tienden), niet 0,06 (zes honderdsten). 1,85 + 0,06 = 1,91, maar dat is fout. Onthoud: 0,6 = 0,60 — voeg een nul toe achteraan.",
          "2": "Je dacht waarschijnlijk dat de eenheid meter en centimeter hetzelfde zijn. Maar de maten staan al in meters: 2,45 m is correct. 2,45 cm zou veel te kort zijn voor een plank. Onthoud: kijk altijd naar de eenheid in de vraag.",
          "3": "Je dacht waarschijnlijk dat de overdracht bij de tienden anders werkt. 8 + 6 = 14 tienden → schrijf 4, onthoud 1. De eenheden worden 1 + 0 + 1 = 2, niet 3. Onthoud: de overdracht is altijd 1, niet het hele getal."
        }
      }
    },
    {
      "id": "GET-KOMMA-PLUS-004",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 0,99 + 0,01?",
      "options": [
        "1",
        "0,100",
        "1,00",
        "0,910"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele overdracht",
            "content": "Soms gaat de overdracht door meerdere posities. 9 + 1 = 10 honderdsten → 1 overdracht. Dan: 9 + 0 + 1 = 10 tienden → weer 1 overdracht naar de eenheden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_overdracht",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Tel op en verwerk de overdrachten. Honderdsten: 9 + 1 = 10 → schrijf 0, onthoud 1. Tienden: 9 + 0 + 1 = 10 → schrijf 0, onthoud 1. Eenheden: 0 + 0 + 1 = 1. Antwoord: 1,00 = 1. Controleer: 1 − 0,01 = 0,99 ✓.",
        "distractorExplanations": {
          "0": "Goed! 0,99 + 0,01 = 1. Twee overdrachten: honderdsten → tienden → eenheden.",
          "1": "Je dacht waarschijnlijk dat de overdrachten niet doorlopen. Maar 99 + 01 = 100 honderdsten = 1 heel. De overdracht gaat door naar de eenheden: het antwoord is 1. Onthoud: controleer door af te trekken: 1 − 0,01 = 0,99.",
          "2": "1,00 is wiskundig gelijk aan 1. Beide antwoorden zijn correct, maar 1 is de standaard schrijfwijze. Onthoud: schrijf geen onnodige nullen achter het laatste cijfer.",
          "3": "Je dacht waarschijnlijk dat de cijfers los van elkaar staan. Maar 0,99 + 0,01 = 1,00 = 1, niet 0,910. Onthoud: zet de komma's recht onder elkaar en tel per kolom op."
        }
      }
    },
    {
      "id": "GET-KOMMA-PLUS-005",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 4,6 + 0,25 + 1,15?",
      "options": [
        "6",
        "5,40",
        "6,40",
        "5,86"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Drie getallen optellen",
            "content": "Maak alle getallen even lang: 4,60 + 0,25 + 1,15. Tel per kolom op van rechts naar links en verwerk elke overdracht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_drie_getallen",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Maak alle getallen even lang: 4,60 + 0,25 + 1,15. Honderdsten: 0 + 5 + 5 = 10 → schrijf 0, onthoud 1. Tienden: 6 + 2 + 1 + 1 = 10 → schrijf 0, onthoud 1. Eenheden: 4 + 0 + 1 + 1 = 6. Antwoord: 6,00 = 6. Controleer: 6 − 1,15 − 0,25 = 4,60 ✓.",
        "distractorExplanations": {
          "0": "Goed! 4,60 + 0,25 + 1,15 = 6,00 = 6. Twee overdrachten maken het een rond getal.",
          "1": "Je dacht waarschijnlijk dat één van de overdrachten niet meegeteld hoeft te worden. Controleer: honderdsten (0+5+5=10) → 1 overdracht, tienden (6+2+1+1=10) → 1 overdracht. Onthoud: tel elke overdracht mee.",
          "2": "Je dacht waarschijnlijk dat de overdracht van de honderdsten niet meegeteld hoeft te worden. Maar 0 + 5 + 5 = 10 honderdsten → 1 overdracht naar de tienden. Onthoud: 10 honderdsten = 1 tiende.",
          "3": "Je dacht waarschijnlijk dat de komma's niet recht onder elkaar staan. Zorg dat je 4,60 schrijft (niet 4,6) zodat alle getallen even lang zijn: 4,60 / 0,25 / 1,15. Onthoud: maak alle getallen even lang door nullen toe te voegen."
        }
      }
    }
  ]
}